module.exports = __webpack_public_path__ + "static/media/a-smarter-harvest-tablet.98c0ff1a.jpg";